/*
 * @Author: Your name
 * @Date:   2020-06-22 19:09:35
 * @Last Modified by: wxm
 * @Last Modified time: 2021-11-26 15:58:40
 */
/* jshint esversion: 6 */
import Vue from 'vue';
import vuex from 'vuex';

import app from '@/store/modules/App';
import User from '@/store/modules/User';

Vue.use(vuex);

const store = new vuex.Store({
    modules: {
        app,
        User
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js